var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("河南智能科技有限公司 © 版权所有")])
}
var staticRenderFns = []

export { render, staticRenderFns }